import React, {
  useRef,
  useState,
  RefObject,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';

import {
  AlarmMetadata,
  AlarmDefinition,
  DataSourceAlarmMetadata,
} from 'types/types';
import 'react-multi-email/dist/style.css';
import { CircularProgress } from '@mui/material';

import VirtualizedTransferList, {
  Ref as VirtualizedTransferListRef,
} from './VirtualizedTransferList';
import OutputElements, {
  NotificationType,
  OutputElementsRef,
} from './OutputElements';
import { Ref as AlarmManagementFormRulesRef } from '../FormRules/FormRules';

interface Props {
  alarmMetaData?: AlarmMetadata;
  alarmDefinitionData: AlarmDefinition | null;
  loadingQueryBuilderData: boolean;
  dataSourceMetadataForAlarm?: DataSourceAlarmMetadata;
  alarmManagementFormRulesRef: React.MutableRefObject<AlarmManagementFormRulesRef | null>;
}

interface OutputRef {
  outputElements: RefObject<OutputElementsRef>;
  virtualizedTransferList: RefObject<VirtualizedTransferListRef>;
}

export interface Ref {
  refs: OutputRef;
}

const Output: ForwardRefRenderFunction<Ref, Props> = (
  {
    alarmMetaData,
    alarmDefinitionData,
    loadingQueryBuilderData,
    dataSourceMetadataForAlarm,
    alarmManagementFormRulesRef,
  },
  ref
) => {
  const virtualizedTransferListRef = useRef<VirtualizedTransferListRef>(null);
  const outputElementsRef = useRef<OutputElementsRef>(null);

  const [selectedNotificationType, setSelectedNotificationType] =
    useState<string>('');

  const refs = {
    outputElements: outputElementsRef,
    virtualizedTransferList: virtualizedTransferListRef,
  };

  useImperativeHandle(ref, () => ({
    refs: refs,
  }));

  return (
    <div className="alarm-form-card-container">
      {loadingQueryBuilderData && (
        <div className="loading-overlay">
          <CircularProgress color="warning" className="circular-progess-icon" />
        </div>
      )}
      <div className="alarm-form-card-title-container">
        <span className="alarm-form-card-title">Output</span>
      </div>
      <div className="alarm-form-elements-container">
        <OutputElements
          ref={outputElementsRef}
          alarmDefinitionData={alarmDefinitionData}
          alarmMetaData={alarmMetaData}
          selectedNotificationType={selectedNotificationType}
          setSelectedNotificationType={setSelectedNotificationType}
        />
        {selectedNotificationType === NotificationType.EMAIL && (
          <VirtualizedTransferList
            ref={virtualizedTransferListRef}
            alarmDefinitionData={alarmDefinitionData}
            dataSourceMetadataForAlarm={dataSourceMetadataForAlarm}
            alarmManagementFormRulesRef={alarmManagementFormRulesRef}
          />
        )}
      </div>
    </div>
  );
};

export default forwardRef<Ref, Props>(Output);
